import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68c1a3be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "origin-text" }
const _hoisted_2 = { class: "text" }

import { onMounted, ref, onBeforeUnmount } from 'vue';
  import _ from 'lodash';

  interface IProps {
    text: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    text: null
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "b8b0049e": (maxRow.value)
}))

  
  const root = ref<HTMLDivElement>();
  const maxRow = ref(0);

  function calcMaxRow() {
    if (root.value) {
      const style = window.getComputedStyle(root.value, null);
      maxRow.value = Math.floor(parseInt(style['height']) / parseInt(style['line-height']));
    }
  }

  const calcMaxRowDebounced =  _.debounce(calcMaxRow, 500);

  onMounted(() => {
    calcMaxRow();
    setTimeout(calcMaxRow, 300);
    window.addEventListener('resize', calcMaxRowDebounced);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', calcMaxRowDebounced);
  });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "component-text-overflow"
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(__props.text), 1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.text), 1)
  ], 512))
}
}

})